<template lang="pug" src="./SimpleCategoryProducts/template.pug"></template>

<script>
import SimpleCategoryProducts from './SimpleCategoryProducts';

import { get, cloneDeep } from '@/helpers';

export default {
    name: 'InfiniteProductList',
    extends: SimpleCategoryProducts,
    data: () => ({
        initialized: false
    }),
    watch: {
        'cart.articlePivots'() {
            if (!this.initialized) this.refetch();
        }
    },
    methods: {
        // refetch() {
        //     this.loading = true;
        //     const shop = get(this.cms, 'shop.id');
        //     let shopCategories = cloneDeep(this.shopCategories);
        //     let categories = [];
        //     if (shopCategories && shopCategories.length >= 1) {
        //         categories = shopCategories.map(category => category.id);
        //     }
        //     let articleIDs = [];
        //     if (this.cart.articlePivots.length) {
        //         articleIDs = this.cart.articlePivots.map(el => {
        //             return parseInt(el.article.id);
        //         });
        //     }
        //     if (articleIDs.length) {
        //         const payload = {
        //             pageInfo: {
        //                 currentPage: parseInt(this.currentPage),
        //                 perPage: parseInt(this.perPage)
        //             },
        //             filters: [
        //                 {
        //                     key: 'shop',
        //                     match: shop.toString()
        //                 },
        //                 {
        //                     key: 'status',
        //                     match: 'enabled'
        //                 },
        //                 {
        //                     key: 'article_ids',
        //                     in: articleIDs
        //                 },
        //                 {
        //                     key: 'qty_sum',
        //                     from: 1
        //                 },
        //                 {
        //                     key: 'categories',
        //                     in: categories
        //                 }
        //             ],
        //             order: 'nr'
        //         };
        //         this.fetchProducts(payload)
        //             .then(response => {
        //                 if (response.pageInfo.currentPage > response.pageInfo.lastPage) {
        //                     this.changePage(response.pageInfo.lastPage);
        //                     return;
        //                 }
        //                 const products = cloneDeep(response);
        //                 if (products.items && products.items.length) {
        //                     products.items.forEach((product, i) => {
        //                         product.position = i + 1;
        //                     });
        //                 }
        //                 this.products = products;
        //                 // this.insertProducts({ products });
        //                 this.loading = false;
        //             })
        //             .finally(() => {
        //                 this.loading = false;
        //                 this.initialized = true;
        //             });
        //     } else {
        //         this.loading = false;
        //     }
        // }
    },
    mounted() {
        const products = { loading: true, pagination: {} };
        this.products = products;
        // this.insertProducts({ products });

        // this.currentPage = get(this.$route, `query.P${this.section.id}`) || 1;
        this.currentPage = 1;

        if (this.cart.articlePivots && this.cart.articlePivots.length) {
            this.loading = true;
            this.refetch();
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.preorder::v-deep .preorder-product
    tr.empty
        td, th
            background: lighten($color-adenauer-orange, 40%) !important
            height: 38px
            // color: white
        td + td,
        th + td
            border-left: 1px solid lighten($color-adenauer-orange, 30%) !important

    tr td button
        display: none !important
    tr.empty td
        .label, input
            display: none !important

    tr td input
        pointer-events: none
</style>
